export default __webpack_public_path__ + "icon-agentf75f36.png";